var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2024 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2024-03-04
 * @brief SEI 커뮤니티 회원가입 - 회사검색 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilState, useRecoilValue } from "recoil";
import { getApiLangState, langId } from "../../../../recoil/langState";
import { comapanyInfo, reLoad } from "../../../../recoil/userState";
//utils
import * as CONST from "../../../../utils/Const";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import { useTrans } from "../../../../utils/langs/useTrans";
export default function CmmJoinCompanyPop() {
    const t = useTrans();
    //recoil
    const [comapanyInfos, setComapanyInfos] = useRecoilState(comapanyInfo);
    const reload = useRecoilValue(reLoad);
    //
    const [errorList, setErrorList] = useState([]);
    const [companyName, setCompanyName] = useState("");
    const [businessNo, setBusinessNo] = useState("");
    const [autoComplete, setAutoComplete] = useState(false);
    const [autoCompleteB, setAutoCompleteB] = useState(false);
    const [comapanyData, setComapanyData] = useState(null);
    const [companyState, setCompanyState] = useState(null);
    const [comapanyAdd, setComapanyAdd] = useState(false);
    const apiLang = useRecoilValue(getApiLangState);
    const langIds = useRecoilValue(langId);
    //
    const [companyItem, setCompanyItem] = useState([]);
    // comapany API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: "/product/companies/signup",
        appQuery: {
            language: apiLang,
        },
        watch: reload + langIds.toString(),
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setCompanyItem(data.body);
            }
        }
    }, [data, langIds]);
    // 회사 입력
    function handleSetCompanyName(e) {
        setErrorList(errorList.filter((err) => err.field !== "companyName"));
        setCompanyName(e.target.value);
        if (e.target.value.length > 0) {
            setAutoComplete(true);
        }
        else {
            setAutoComplete(false);
        }
        setComapanyAdd(false);
    }
    // 회사 입력
    function handlesetBusinessNo(e) {
        setErrorList(errorList.filter((err) => err.field !== "companyName"));
        setBusinessNo(e.target.value);
        if (e.target.value.length > 0) {
            setAutoCompleteB(true);
        }
        else {
            setAutoCompleteB(false);
        }
        setComapanyAdd(false);
    }
    function DownCompany(e) {
        if (e.key == "Enter") {
            handleAutoComplete(e.target.value, "comanyN");
        }
    }
    function DownBusiness(e) {
        if (e.key == "Enter") {
            handleAutoComplete(e.target.value, "businessN");
        }
    }
    // 회사 선택
    function handleAutoComplete(item, type) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/signup`,
                appQuery: {
                    companyId: type !== "comanyN" ? item.companyId : companyName,
                    businessNo: type !== "businessN" ? item.businessNo : businessNo.toString(),
                    language: apiLang,
                },
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setComapanyData(data.body);
                    setCompanyName(item.companyName);
                    setBusinessNo(item.businessNo);
                    setCompanyState(item);
                    if (type == "company") {
                        setAutoComplete(false);
                    }
                    else {
                        setAutoCompleteB(false);
                    }
                    setComapanyAdd(false);
                }
                else {
                    // api if need error handle
                    if (type == "companyN") {
                        setAutoComplete(false);
                    }
                    else {
                        setAutoCompleteB(false);
                    }
                    setComapanyAdd(true);
                    setComapanyData(null);
                    setBusinessNo("");
                    setCompanyState(null);
                }
            }
        });
    }
    function CompanyNew(e) {
        setErrorList([]);
        setCompanyName("");
        setBusinessNo("");
        setAutoComplete(false);
        setAutoCompleteB(false);
        setComapanyData(null);
        setComapanyAdd(false);
        CUTIL.jsopen_InteriorPopup(e);
    }
    function Close(id) {
        setErrorList([]);
        setCompanyName("");
        setBusinessNo("");
        setAutoComplete(false);
        setAutoCompleteB(false);
        setComapanyData(null);
        setComapanyAdd(false);
        setCompanyState(null);
        setComapanyInfos({
            companyId: -1,
            companyName: "",
        });
        CUTIL.jsclose_InPopup(id);
    }
    function CompanyDone(id) {
        setErrorList([]);
        setCompanyName("");
        setBusinessNo("");
        setAutoComplete(false);
        setAutoCompleteB(false);
        setComapanyData(null);
        setComapanyAdd(false);
        setCompanyState(null);
        setComapanyInfos({
            companyId: companyState.id,
            companyName: companyState.companyName,
        });
        CUTIL.jsclose_InPopup(id);
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "pop-cmm-company", className: "popup-layer js-layer hidden inner-popup popup-type1 pop-login w350" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: t("라벨.회사찾기") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close("pop-cmm-company") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsxs("div", Object.assign({ className: "popup__body find-company" }, { children: [_jsx("form", Object.assign({ action: "", method: "", name: "popjoin2" }, { children: _jsxs("ul", Object.assign({ className: "form__input mt-9" }, { children: [_jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "companyname", className: "star" }, { children: t("라벨.회사명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "companyname", placeholder: t("라벨.텍스트입력"), value: companyName, onChange: (e) => handleSetCompanyName(e), className: errorList.filter((err) => err.field === "companyName").length > 0 ? "input-error" : "" }), autoComplete && (_jsx("ul", Object.assign({ className: "autocomplete-box" }, { children: _jsx(CompanyAutoCompltet, { companyItem: companyItem, companyName: companyName, handleAutoComplete: handleAutoComplete }) })))] }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "companynum", className: "star" }, { children: t("라벨.사업자등록번호") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", id: "companynum", placeholder: t("라벨.숫자만입력"), value: businessNo, onChange: (e) => handlesetBusinessNo(e) }), autoCompleteB && (_jsx("ul", Object.assign({ className: "autocomplete-box" }, { children: _jsx(BusinessAutoCompltet, { companyItem: companyItem, businessNo: businessNo, handleAutoComplete: handleAutoComplete }) })))] }))] })] })) })), _jsxs("div", Object.assign({ className: "brd-top-1 pt-24 mt-56" }, { children: [_jsx("p", { children: t("라벨.회사검색없음") }), _jsx("div", Object.assign({ className: "flex-right mt-8" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray js-open", "data-pop": "pop-cmm-new-comp", onClick: (e) => CompanyNew(e) }, { children: _jsx("span", { children: t("라벨.신규등록") }) })) })), _jsx("div", Object.assign({ className: "content__info mt-8" }, { children: comapanyData && (_jsxs("ul", { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.회사명") })), _jsxs("div", Object.assign({ className: "txt" }, { children: [comapanyData.companyName, comapanyData.isApproved == 1 ? "(미승인)" : ""] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.사업자등록번호") })), _jsx("p", Object.assign({ className: "txt" }, { children: comapanyData.businessNo }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.회사URL") })), _jsx("div", Object.assign({ className: "txt" }, { children: _jsx("a", Object.assign({ href: comapanyData.url ? comapanyData.url : "#", target: "_blank", className: "link-txt", onClick: (e) => !comapanyData.url && e.preventDefault() }, { children: comapanyData.url ? comapanyData.url : "-" })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.대표자관리") })), _jsx("p", Object.assign({ className: "txt" }, { children: comapanyData.administrator ? comapanyData.administrator : "-" }))] })] })) }))] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "js-close bg-gray", onClick: (e) => Close("pop-cmm-company") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", className: "", disabled: companyState ? false : true, onClick: (e) => CompanyDone("pop-cmm-company") }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] })) }));
}
function CompanyAutoCompltet(props) {
    const { companyItem, companyName, handleAutoComplete } = props;
    //
    return (_jsx(_Fragment, { children: companyItem &&
            companyName &&
            companyItem
                .filter((data) => data.companyName.toUpperCase().includes(companyName.toUpperCase()))
                .map((data, idx) => (_jsx("li", Object.assign({ onClick: (e) => handleAutoComplete(data, "company") }, { children: _jsxs("a", { children: [data.companyName.substring(0, data.companyName.toUpperCase().indexOf(companyName.toUpperCase())), _jsx("span", Object.assign({ className: "highlight" }, { children: data.companyName.substring(data.companyName.toUpperCase().indexOf(companyName.toUpperCase()), data.companyName.toUpperCase().indexOf(companyName.toUpperCase()) + companyName.length) })), data.companyName.substring(data.companyName.toUpperCase().indexOf(companyName.toUpperCase()) + companyName.length)] }) }), idx))) }));
}
function BusinessAutoCompltet(props) {
    const { companyItem, businessNo, handleAutoComplete } = props;
    //
    return (_jsx(_Fragment, { children: companyItem &&
            businessNo &&
            companyItem
                .filter((data) => data.businessNo.toUpperCase().includes(businessNo.toUpperCase()))
                .map((data, idx) => (_jsx("li", Object.assign({ onClick: (e) => handleAutoComplete(data, "business") }, { children: _jsxs("a", { children: [data.businessNo.substring(0, data.businessNo.toUpperCase().indexOf(businessNo.toUpperCase())), _jsx("span", Object.assign({ className: "highlight" }, { children: data.businessNo.substring(data.businessNo.toUpperCase().indexOf(businessNo.toUpperCase()), data.businessNo.toUpperCase().indexOf(businessNo.toUpperCase()) + businessNo.length) })), data.businessNo.substring(data.businessNo.toUpperCase().indexOf(businessNo.toUpperCase()) + businessNo.length)] }) }), idx))) }));
}
